export enum DashboardSearchTerms {
    PLACED_AT = 'placedAt',
}
